import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import logo from '../images/jmc-logo.png';
import bgImage from '../images/nigam3.jpg';
import { login } from '../../api';

function Loginpage({ setUserRole, setUserEmail }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      setUserRole(user.role);
      setUserEmail(user.email || '');
      navigate('/Homepage');
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>

      {/* ── Left: Form ─────────────────────────────────────── */}
      <div style={{
        width: 480,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '48px 52px',
        background: '#fff',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src={logo} alt="MCJS Logo" style={{ width: 90, height: 90, borderRadius: '50%' }} />
          <div style={{ fontSize: 13, color: '#6B7280', marginTop: 8 }}>OMS-JMC Vehicle Entry System</div>
        </div>

        <h2 style={{ fontSize: 26, fontWeight: 800, color: '#1A202C', marginBottom: 4 }}>Welcome Back</h2>
        <p style={{ fontSize: 14, color: '#6B7280', marginBottom: 28 }}>Sign in to your account to continue</p>

        {error && (
          <div style={{
            background: '#FEE2E2', color: '#991B1B',
            border: '1px solid #FECACA',
            borderRadius: 8, padding: '10px 14px',
            fontSize: 13.5, marginBottom: 20,
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 18 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
              Email Address
            </label>
            <input
              type="email"
              placeholder="admin@jmc.in"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{
                width: '100%', padding: '11px 14px',
                border: '1.5px solid #D1D5DB', borderRadius: 8,
                fontSize: 14.5, outline: 'none', boxSizing: 'border-box',
              }}
              onFocus={e => (e.target.style.borderColor = '#1E5FA8')}
              onBlur={e  => (e.target.style.borderColor = '#D1D5DB')}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{
                width: '100%', padding: '11px 14px',
                border: '1.5px solid #D1D5DB', borderRadius: 8,
                fontSize: 14.5, outline: 'none', boxSizing: 'border-box',
              }}
              onFocus={e => (e.target.style.borderColor = '#1E5FA8')}
              onBlur={e  => (e.target.style.borderColor = '#D1D5DB')}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              background: loading ? '#93B4D8' : '#1E5FA8',
              color: '#fff', border: 'none',
              borderRadius: 8, padding: '12px 0',
              fontSize: 15, fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              transition: 'background .15s',
            }}
          >
            {loading
              ? <><span className="spinner-border spinner-border-sm" style={{ width: 16, height: 16 }} /> Signing in…</>
              : <><LogIn size={17} /> Sign In</>
            }
          </button>
        </form>
      </div>

      {/* ── Right: Background Image only ───────────────────── */}
      <div style={{
        flex: 1,
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }} />
    </div>
  );
}

export default Loginpage;
